import React, { useEffect, useState } from "react";
import TopBar from "@/components/TopBar";
import AudioButton from "@/components/AudioButton";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Play, Sparkles, Users, Trophy, Gamepad2, Video } from "lucide-react";
import { motion } from "framer-motion";

const typeIcon = { video: Video, quiz: Sparkles, game: Gamepad2, shared: Users };
const typeColor = { video: "btn-child", quiz: "btn-child-amber", game: "btn-child-rose", shared: "btn-child-green" };

export default function ChildHome() {
  const [challenges, setChallenges] = useState([]);
  useEffect(() => { api.get("/challenges").then(r => setChallenges(r.data)); }, []);

  return (
    <div className="min-h-screen bg-childhub">
      <TopBar variant="child"/>
      <main className="max-w-6xl mx-auto p-6 sm:p-12">
        <motion.div initial={{opacity:0, y:20}} animate={{opacity:1, y:0}}
          className="child-card p-8 mb-8 flex flex-col sm:flex-row items-center gap-6">
          <img src="https://static.prod-images.emergentagent.com/jobs/b25cc76c-c7dd-47c3-a0fd-f45ad7afe07b/images/9d5f8dd84056b8b89e3c1a6fced798ad700b53847df3968be83da972e46d10dc.png"
            alt="mascot" className="w-32 h-32 animate-float" data-testid="mascot"/>
          <div className="text-center sm:text-left flex-1">
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-800">Today's Quest!</h1>
            <p className="text-slate-600 text-lg mt-1">Pick a card. Earn stars. Have fun.</p>
            <div className="mt-4 flex flex-wrap gap-3 justify-center sm:justify-start">
              <AudioButton text="Hi friend! Pick a card and let's play!" voice="child" label="Hear Sparky" testId="welcome-audio"/>
              <Link to="/shared" className="inline-flex items-center gap-2 rounded-full bg-orange-100 text-orange-700 border-2 border-orange-200 px-4 py-2 font-semibold" data-testid="shared-link">
                <Users className="w-5 h-5"/> Shared
              </Link>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {challenges.map((c, i) => {
            const Icon = typeIcon[c.type] || Play;
            return (
              <motion.div key={c.id} initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{delay: i*0.05}}
                className="child-card p-6 flex flex-col items-center text-center" data-testid={`challenge-card-${c.type}`}>
                <div className="w-16 h-16 rounded-2xl bg-sky-100 flex items-center justify-center mb-3">
                  <Icon className="w-8 h-8 text-sky-600"/>
                </div>
                <h3 className="font-display font-bold text-xl text-slate-800">{c.title}</h3>
                <p className="text-slate-500 text-sm mb-4">{c.caption_text}</p>
                <div className="flex items-center gap-2 text-amber-600 text-sm font-bold mb-4">
                  <Trophy className="w-4 h-4"/> {c.xp_value} XP
                </div>
                <Link to={`/child/play/${c.id}`} className={`${typeColor[c.type] || "btn-child"} text-base inline-block`} data-testid={`play-${c.id}`}>
                  <Play className="w-5 h-5 inline mr-1 -mt-0.5"/> Play
                </Link>
              </motion.div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
